module.exports = __webpack_public_path__ + "static/jonathan-b66368f74ea8975bdded2e59edac266f.png";